"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable = (function () {
    function Observable() {
        this.registeredObservers = new Array();
    }
    Observable.prototype.registerObserver = function (observer, owner) {
        if (observer) {
            this.registeredObservers.push({ observer: observer, owner: owner });
        }
    };
    Observable.prototype.unregisterObserver = function (observer) {
        var _this = this;
        this.registeredObservers.forEach(function (item, index) {
            if (item.observer !== observer) {
                return;
            }
            _this.registeredObservers.splice(index, 1);
        });
    };
    Observable.prototype.unregisterObservers = function (owner) {
        this.registeredObservers = this.registeredObservers.filter(function (item) { return item.owner !== owner; });
    };
    Observable.prototype.reset = function () {
        this.currentState = null;
    };
    Observable.prototype.notifyObservers = function (newState) {
        var isNewStateUndefined = typeof newState === 'undefined';
        var isStatelessObservable = typeof this.currentState === 'undefined' && isNewStateUndefined;
        if (isStatelessObservable || this.currentState !== newState) {
            this.registeredObservers.forEach(function (item) { return item.observer(newState); });
        }
        this.currentState = newState;
    };
    return Observable;
}());
exports.Observable = Observable;
